import React from "react";
import GenericCard from "@ui-components/Card/GenericCard";
import { TENANT_OUT_OF_SCOPE_HINT, TENANT_OUT_OF_SCOPE_MESSAGE } from "@shared/helpers/tenantScope";

/**
 * Shown when the backend refuses the selected tenant as outside the caller's
 * scope (CTX-866), instead of the overview.
 *
 * Neither "your tenant is currently empty" nor "monitoring unavailable" is
 * true here: the services may well exist and be monitored, this user just may
 * not see them.
 */
const TenantOutOfScope: React.FC = () => (
  <div className="min-h-[calc(100vh-10rem)] flex items-center justify-center">
    <div className="w-1/2">
      <GenericCard
        isCollapsible={false}
        bodyContent={
          <div className="flex flex-col items-center justify-center text-center space-y-4 p-6">
            <div className="bg-semantic-bg-warning-secondary text-semantic-text-warning inline-flex items-center justify-center border border-[var(--color-utility-warning-600)] rounded-md p-2">
              <svg
                className="h-10 w-10"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={1.4}
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="5" y="11" width="14" height="9" rx="2" />
                <path d="M8 11V8a4 4 0 0 1 8 0v3" />
              </svg>
            </div>

            <h3 className="text-1xl font-bold">{TENANT_OUT_OF_SCOPE_MESSAGE}</h3>

            <p className="text-sm text-semantic-text-secondary">{TENANT_OUT_OF_SCOPE_HINT}</p>
          </div>
        }
      />
    </div>
  </div>
);

export default TenantOutOfScope;
